import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

export const CustomDateAdapter = ({locale, formats, instance}) => {
    const adapter = new AdapterDayjs({locale, formats, instance});

    const constructDayObject = (day) => ({charAt: () => constructUpperObject(day)});
    const constructUpperObject = (text) => ({toUpperCase: () => text});

    return {
        ...adapter,

        getWeekdays() {
            // Feel free to replace this with your custom value
            // e.g const customWeekdays = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
            const customWeekdays = ["Pir.", "Ant.", "Tre.", "Ket.", "Pen.", "Šeš.", "Sek."];

            return customWeekdays.map((day) => constructDayObject(day));
        }
    };
}
